import { useEffect, useRef, useState } from "react";
import {
  NavLink,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import ChevronLeftIcon from "../../../assets/svg/ChevronLeftIcon";
import { getApplicantList, getJobById } from "../../../endpoints/job.service";
import Spinner from "../../../components/Spinner/Spinner";
import { useDispatch } from "react-redux";
import { setJobDetail } from "../../../store/actions/job.action";
import EmailOpenIconFilled from "@assets/svg/EmailOpenIconFilled";
import SubmissionQueueModal from "./components/SubmissionQueueModal";
import CandidateSentSuccessModal from "./components/CandidateSentSuccessModal";
import { getPaymentHistoryDetails } from "@endpoints/stripe.service";
import { ArrowLeft } from "lucide-react";

const tabs = [
  { name: "Job Details", path: "job-post" },
  { name: "Application Management", path: "applicants" },
  // { name: "Shortlisted", path: "shortlisted" },
];

const JobDetail = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { jobId } = useParams();
  const dispatch = useDispatch();
  const hasFetched = useRef(false);

  const [loading, setLoading] = useState(true);
  const [showSubmissionQueueModal, setShowSubmissionQueueModal] =
    useState(false);
  const [showCandidateSentModal, setShowCandidateSentModal] = useState(false);

  useEffect(() => {
    if (!hasFetched.current) {
      hasFetched.current = true;
      fetchJobDetails();
      fetchPaymentDetails();
    }
  }, []);

  const fetchJobDetails = async () => {
    try {
      const jobResponse = await getJobById({ jobId });
      const { data: jobData, success: jobSuccess } = jobResponse;
      if (jobSuccess) {
        const applicantResponse = await getApplicantList(jobId);
        const { data: applicantData, success: applicantSuccess } =
          applicantResponse;
        if (applicantSuccess) {
          dispatch(setJobDetail({ ...jobData, applicantData }));
        } else {
          dispatch(setJobDetail({ ...jobData, applicantData }));
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchPaymentDetails = async () => {
    try {
      const { data, success } = await getPaymentHistoryDetails({
        id: jobId,
        type: "jobpost",
        by: "job",
      });
      console.log("This is payment details", data);
    } catch (error) {
      console.error("Error fetching payment details", error);
    }
  };

  return (
    <div className="flex flex-1 min-h-0 gap-3">
      {/* Left section */}
      <div className="flex flex-col flex-1 min-h-0 gap-3">
        {/* Header */}
        <div className="flex items-center rounded-md bg-white border overflow-hidden">
          <button
            onClick={() => navigate("/job")}
            className="group flex items-center gap-2 hover:bg-slate-100 h-11 pl-3 pr-10"
          >
            <span className="rounded-full p-1 border text-content group-hover:bg-slate-600 group-hover:text-white">
              <ArrowLeft size={13} />
            </span>
            <span className="font-semibold text-xs">Jobs</span>
          </button>
          {/* Tab section */}
          <div className="flex items-center flex-1">
            {tabs?.map((tab) => {
              return (
                <NavLink
                  key={tab?.path}
                  to={tab?.path}
                  className={({ isActive }) =>
                    `flex items-center h-11 px-7 ${
                      isActive
                        ? "bg-slate-600 text-white"
                        : "text-slate-600 hover:bg-slate-100"
                    }`
                  }
                >
                  <span className="font-medium text-xs">{tab?.name}</span>
                </NavLink>
              );
            })}
          </div>
        </div>
        {/* Main Body */}
        <div className="flex flex-col min-h-0 flex-1">
          <Outlet />
        </div>
      </div>

      {/* Right section */}
      <div className="w-[25%] rounded-md bg-white border h-max overflow-hidden">
        <div className="flex items-center relative gap-2 p-5">
          <div className="rounded-md bg-charcoal text-white text-3xl font-medium h-10 w-10 flex items-center justify-center shrink-0">
            J
          </div>
          <div className="flex flex-col gap-0.5">
            <span className="uppercase text-xss tracking-wider font-semibold text-light-black">
              Job Post
            </span>
            <span className="font-semibold text-sm">Job posting fee test</span>
            <span className="font-semibold text-content-muted text-xss">
              JO-T17270
            </span>
            <span className="text-xss font-medium text-light-black">
              Hiring company · Company not disclosed
            </span>
          </div>
          <div className="self-start rounded-full bg-gray-100 text-xss text-content-muted font-semibold py-1 px-2">
            Closed
          </div>
        </div>

        <div className="flex border-t border-light-gray flex-1 gap-2 px-5 py-3">
          <button className="border border-light-grey rounded-md py-2.5 flex-1 text-xss text-content-muted font-semibold">
            Edit job
          </button>
          <button className="border border-light-grey rounded-md py-2.5 flex-1 text-xss text-content-muted font-semibold">
            Withdraw job post
          </button>
        </div>

        <div className="flex flex-col pl-5 bg-black py-4">
          <span className="text-white font-medium text-sm">Publishing details</span>
          <span className="text-light-grey text-xss">Current job post</span>
        </div>
      </div>
    </div>
  );

  // return (
  //   <div className="flex flex-col rounded-lg bg-white w-full flex-grow px-4 py-3">
  //     <div className="flex items-center gap-[32rem]">
  //       <button onClick={() => navigate("/job")} className="flex items-center">
  //         <ChevronLeftIcon className={"w-4 h-4"} fill="#4d4d4d" />
  //         <label className="text-xs font-medium text-charcoal cursor-pointer">
  //           Back to listing
  //         </label>
  //       </button>
  //       <button
  //         onClick={() => setShowSubmissionQueueModal(true)}
  //         className="border rounded-md h-10 w-10 flex items-center justify-center hover:bg-gray-100"
  //       >
  //         {/* @ts-ignore */}
  //         <EmailOpenIconFilled fill="#2e2e2e" />
  //       </button>
  //     </div>

  //     {loading ? (
  //       <div className="flex justify-center items-center h-screen">
  //         <Spinner />
  //       </div>
  //     ) : (
  //       <>
  //         {/* Header starts here */}
  //         <div className="flex items-end justify-between border-b px-3 mt-5 pb-2">
  //           <div className="flex items-center gap-10">
  //             {tabs?.map((item, index) => {
  //               const isActive = pathname?.includes(item?.path);
  //               return (
  //                 <button
  //                   onClick={() => navigate(item?.path)}
  //                   key={index}
  //                   className={`flex items-center ${
  //                     isActive ? "border-b border-primary" : ""
  //                   }`}
  //                 >
  //                   <span
  //                     className={`text-xs ${
  //                       isActive ? "text-charcoal font-medium" : "text-gray-500"
  //                     }`}
  //                   >
  //                     {item?.name}
  //                   </span>
  //                 </button>
  //               );
  //             })}
  //           </div>
  //           {/* <button
  //             onClick={() => setShowSubmissionQueueModal(true)}
  //             className="flex items-center gap-2 text-xs font-medium text-charcoal border border-primary rounded-md h-9 px-3 hover:bg-gray-100"
  //           >
  //             <EmailOpenIconFilled fill="#2e2e2e" />
  //             Submission Queue
  //           </button> */}
  //         </div>
  //         {/* Header ends here  */}
  //         <div className="flex flex-1 flex-col overflow-y-hidden no-scrollbar">
  //           <Outlet />
  //         </div>
  //         {/* SubmissionQueueModal */}
  //         <SubmissionQueueModal
  //           openModal={showSubmissionQueueModal}
  //           setOpenModal={setShowSubmissionQueueModal}
  //           jobId={jobId}
  //           onSubmit={() => {
  //             setShowCandidateSentModal(true);
  //           }}
  //         />
  //         {/* CandidateSentSuccessModal */}
  //         <CandidateSentSuccessModal
  //           openModal={showCandidateSentModal}
  //           setOpenModal={setShowCandidateSentModal}
  //           jobId={jobId}
  //         />
  //       </>
  //     )}
  //   </div>
  // );
};

export default JobDetail;
